var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendorCaptionWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2367_86568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3694 40.9513L67.4178 29.2177V54.4954L44.3108 65.8984L44.3694 40.9513ZM15.2623 23.9546L41.01 12.071L64.5995 23.9717L41.409 35.7775L15.2623 23.9546ZM40.8207 5.66016L6.67969 21.7374L6.74015 37.6159L12.6215 40.542L12.5757 28.6912L38.3692 41.0149L38.3094 66.2912L12.6215 52.9704L12.602 47.9403L6.67969 44.9937L6.7249 56.6381L40.7674 74.2911L73.3597 58.2071V21.7748L40.8207 5.66016Z",
    fill: "#F2F3EE"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.1368 63.8228L52.2339 68.5481L52.1094 58.8352L62.1368 53.8433V63.8228Z",
    fill: "#F2F3EE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2422 16.6927L28.4734 11.4111L62.1356 28.0694L62.1458 38.6885L52.2327 43.0221V33.6533L17.2422 16.6927Z",
    fill: "#F2F3EE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2367_86568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.68,
    height: 68.631,
    fill: "white",
    transform: "translate(6.67969 5.66016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorCaptionWhite);
export default __webpack_public_path__ + "static/media/vendor-caption-white.115bd86f9f6fb203ad9deb78f48e37bd.svg";
export { ForwardRef as ReactComponent };